/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { compact, toLower, startCase } from 'lodash';
export const fullName = nameObj => {
  if (!nameObj) return '';
  return compact([nameObj.firstName, nameObj.middleName, nameObj.lastName, nameObj.suffixName]).join(' ');
};
export const joinName = function () {
  for (var _len = arguments.length, partsOfName = new Array(_len), _key = 0; _key < _len; _key++) {
    partsOfName[_key] = arguments[_key];
  }
  return partsOfName.map(p => p.trim()).filter(p => p).join(' ');
};
export const formatAddress = address => {
  return compact([address.lineText, address.additionalLineText, address.city, compact([address.state, address.zipcode]).join(' ')]).join(', ');
};
export const formatGroupAddress = address => {
  return compact([address.addressLineOne, address.addressLineTwo, address.city, compact([address.state, address.zipcode]).join(' ')]).join(', ');
};
export const titleCase = text => {
  return startCase(toLower(text));
};